// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "gothamRoundedBold", sans-serif;
}
.App {
  text-align: center;
}

.App-header {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
  background: gray;
}

@media (min-width: 1000px) {
  .App-header {
    background: gray; /* background gray untuk ukuran large */
  }
}

.card-phone {
  /* border: 2px white solid; */
  padding: 0 2rem;
  border-radius: 15%;
  height: 80vh;
}

.hokben-container {
  /* padding: 20px; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
}

.modal-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  outline: none;
  width: 300px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.btn-main {
  width: 4rem;
  height: 4rem;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
}

.btn-danger {
  background: red;
}

.phonepad-grid {
  padding: 0;
  list-style-type: none;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  justify-items: center;
}

.phonepad-btn {
  width: 60px;
  height: 60px;
  font-size: 1.5rem;
  border-radius: 50%;
  text-align: center;
  display: inline-block;
}

.close-btn {
  margin: 20px auto 0;
  width: 100px;
  display: block;
  font-weight: 600;
  cursor: pointer;
  padding: 0.375rem 0.75rem;
  font-size: 1rem !important;
  color: #fff;
  background-color: #d91319;
  border-color: #d91319;
  border-radius: 40px;
}

.dots::after {
  content: "";
  display: inline-block;
  width: 1em;
  text-align: left;
  animation: ellipsis steps(4, end) 1s infinite;
}

@keyframes ellipsis {
  0% {
    content: "";
  }
  25% {
    content: ".";
  }
  50% {
    content: "..";
  }
  75% {
    content: "...";
  }
}

@media (max-width: 600px) {
  .modal-content {
    width: 90%;
  }

  .phonepad-btn {
    width: 50px;
    height: 50px;
    font-size: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;AAC9C;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB,EAAE,uCAAuC;EAC3D;AACF;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,0BAA0B;EAC1B,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":["* {\n  font-family: \"gothamRoundedBold\", sans-serif;\n}\n.App {\n  text-align: center;\n}\n\n.App-header {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n  background: gray;\n}\n\n@media (min-width: 1000px) {\n  .App-header {\n    background: gray; /* background gray untuk ukuran large */\n  }\n}\n\n.card-phone {\n  /* border: 2px white solid; */\n  padding: 0 2rem;\n  border-radius: 15%;\n  height: 80vh;\n}\n\n.hokben-container {\n  /* padding: 20px; */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.75);\n}\n\n.modal-content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: white;\n  padding: 20px;\n  border-radius: 10px;\n  outline: none;\n  width: 300px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n}\n\n.btn-main {\n  width: 4rem;\n  height: 4rem;\n  border: none;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.4);\n}\n\n.btn-danger {\n  background: red;\n}\n\n.phonepad-grid {\n  padding: 0;\n  list-style-type: none;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n  justify-items: center;\n}\n\n.phonepad-btn {\n  width: 60px;\n  height: 60px;\n  font-size: 1.5rem;\n  border-radius: 50%;\n  text-align: center;\n  display: inline-block;\n}\n\n.close-btn {\n  margin: 20px auto 0;\n  width: 100px;\n  display: block;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem !important;\n  color: #fff;\n  background-color: #d91319;\n  border-color: #d91319;\n  border-radius: 40px;\n}\n\n.dots::after {\n  content: \"\";\n  display: inline-block;\n  width: 1em;\n  text-align: left;\n  animation: ellipsis steps(4, end) 1s infinite;\n}\n\n@keyframes ellipsis {\n  0% {\n    content: \"\";\n  }\n  25% {\n    content: \".\";\n  }\n  50% {\n    content: \"..\";\n  }\n  75% {\n    content: \"...\";\n  }\n}\n\n@media (max-width: 600px) {\n  .modal-content {\n    width: 90%;\n  }\n\n  .phonepad-btn {\n    width: 50px;\n    height: 50px;\n    font-size: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
